import LockScroll from './LockScroll.js';

const SELECTOR = {
  BURGER_MENU_BTN: 'js-burger-menu',
  CLOSE_BTN: 'js-mobile-menu-close',
  MOBILE_MENU_CONTENT: 'js-mobile-menu',
};

const $burger = $(`.${SELECTOR.BURGER_MENU_BTN}`);
const $close = $(`.${SELECTOR.CLOSE_BTN}`);
const $mobileMenu = $(`.${SELECTOR.MOBILE_MENU_CONTENT}`);
const lockScroll = new LockScroll();

export default function mobileMenu() {
    if ( !$mobileMenu.length ) {
        return null;
    }

    const toggleLockScroll = () => {
        if ($mobileMenu.hasClass('_active')) {
            lockScroll.lock();
        } else {
            lockScroll.unlock();
        }
    }

    $burger.on('click', ()=> {
        $mobileMenu.addClass('_active');
        toggleLockScroll();
    })

    $close.on('click', ()=> {
        $mobileMenu.removeClass('_active');
        toggleLockScroll();
    })
}


// WEBPACK FOOTER //
// ./_layout/js/mobileMenu.js